import React, { useState, useEffect, useRef } from "react";
import { Link, Navigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useQueryClient } from "@tanstack/react-query";

import { userLoggedOut } from "../../actions/dashboardActions";
import { resetSession } from "../../shared/session";
import PageLayout from "../../components/PageLayout";
import ScrollToTop from "../../components/utils/ScrollToTop";
import Card from "../../components/Card";

function Logout() {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const [state, setState] = useState({
    loading: true,
    error: null,
    redirect: false,
  });

  // Ref guard prevents StrictMode double-mount from firing a second request
  const hasInitiated = useRef(false);

  useEffect(() => {
    if (hasInitiated.current) return;
    hasInitiated.current = true;

    const url = "/api/logout";

    const fetchData = async () => {
      resetSession(queryClient);
      try {
        const response = await fetch(url, {
          method: "POST",
          credentials: "same-origin",
        });
        const data = await response.json();
        if (data.status === "success") {
          dispatch(userLoggedOut());
          setState((prevState) => ({
            ...prevState,
            loading: false,
          }));
        } else if (data.status === "error") {
          setState((prevState) => ({
            ...prevState,
            loading: false,
            redirect: true,
          }));
        }
      } catch (error) {
        console.error("Logout request failed", error);
        setState((prevState) => ({
          ...prevState,
          loading: false,
          redirect: true,
        }));
      }
    };

    fetchData();
  }, [dispatch, queryClient]);

  if (state.loading) {
    return null;
  }

  if (state.redirect) {
    return <Navigate to="/login" />;
  }

  return (
    <PageLayout pageWidth="narrow">
      <ScrollToTop />
      <Card title="We’ve signed you out" removeTopPadding headingSize="1">
        <p>If you signed out accidentally, get a new link to sign in below.</p>

        <p>
          Get a new link to <Link to="/login">sign in instantly</Link>.
        </p>
      </Card>
    </PageLayout>
  );
}

export default Logout;
